import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

interface DropdownOption {
	value: string;
	label: string;
}

interface FilterDropdownProps {
	options: DropdownOption[];
	selectedValue: string;
	onChange: (value: string) => void;
	triggerLabel?: string;
	placeholder?: string;
}

const FilterDropdown: React.FC<FilterDropdownProps> = ({
	options,
	selectedValue,
	onChange,
	triggerLabel = 'Filter',
	placeholder = 'Select an option',
}) => {
	const selectedOption = options.find(option => option.value === selectedValue);
	const displayLabel = selectedOption ? selectedOption.label : placeholder;

	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<button
					className='flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ghana-red'
					aria-label={triggerLabel}
				>
					<span>{displayLabel}</span>
					<svg
						className='w-5 h-5 ml-2 -mr-1'
						xmlns='http://www.w3.org/2000/svg'
						viewBox='0 0 20 20'
						fill='currentColor'
						aria-hidden='true'
					>
						<path
							fillRule='evenodd'
							d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
							clipRule='evenodd'
						/>
					</svg>
				</button>
			</DropdownMenu.Trigger>

			<DropdownMenu.Portal>
				<DropdownMenu.Content
					className='min-w-[220px] bg-white rounded-md shadow-lg p-1 z-50 animate-slideDownAndFade'
					sideOffset={5}
				>
					{options.map(option => (
						<DropdownMenu.Item
							key={option.value}
							className={`relative flex items-center px-8 py-2 text-sm cursor-default select-none outline-none ${
								option.value === selectedValue
									? 'bg-ghana-red text-white'
									: 'text-gray-700 hover:bg-gray-100'
							}`}
							onSelect={() => onChange(option.value)}
						>
							{option.label}
							{option.value === selectedValue && (
								<div className='absolute left-2 flex h-3.5 w-3.5 items-center justify-center'>
									<svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z'
											fill='currentColor'
											fillRule='evenodd'
											clipRule='evenodd'
										></path>
									</svg>
								</div>
							)}
						</DropdownMenu.Item>
					))}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
};

export default FilterDropdown;
